import { InfoOutline } from '@mui/icons-material';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import { CopyButton } from '../../../components/general/CopyButton';

type VNummerProps = {
  readonly vNummer: string | null;
  readonly modulSapId: number | null;
  readonly akaModulId: string | null;
};

export const VNummer = ({ vNummer, modulSapId, akaModulId }: VNummerProps) => {
  if (!vNummer) {
    return null;
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Typography variant="labelSmLight">{vNummer}</Typography>
      {(modulSapId ?? akaModulId) && (
        <Tooltip
          title={
            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto', columnGap: 1, alignItems: 'center' }}>
              {modulSapId && (
                <>
                  <span>SAP-ID:</span>
                  <span>{modulSapId}</span>
                  <CopyButton text={modulSapId.toString()} showOnTooltip />
                </>
              )}
              {akaModulId && (
                <>
                  <span>AKA-Modul-ID:</span>
                  <span>{akaModulId}</span>
                  <CopyButton text={akaModulId} showOnTooltip />
                </>
              )}
            </Box>
          }
        >
          <InfoOutline sx={{ fontSize: '16px' }} />
        </Tooltip>
      )}
    </Stack>
  );
};
